import type { MessagesSearchResponse } from '@lio/api-types';
import { Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { VirtualizedMessages } from '@pages/PolicyDetails/dialogs/MessagesDialog/components/VirtualizedMessages';
import { MessageSearchResultItem } from './components/MessageSearchResultItem';
import type { RefObject } from 'react';

export interface SearchChatHistoryProps {
  results: MessagesSearchResponse['items'];
  scrollRef: RefObject<HTMLDivElement | null>;
  loadMore: () => void;
  hasMore: boolean;
  isLoading: boolean;
  searchTerm: string;
  onSelectMessage: (id: string) => void;
}

export const SearchChatHistoryView = ({
  results,
  scrollRef,
  loadMore,
  hasMore,
  isLoading,
  searchTerm,
  onSelectMessage,
}: SearchChatHistoryProps) => {
  return (
    <Grid size={{ xs: 12 }} ref={scrollRef}>
      {results.length > 0 ? (
        <VirtualizedMessages
          messages={results}
          scrollRef={scrollRef}
          loadNewer={() => {
            loadMore();
          }}
          /* more results exist if we haven't reached total yet */
          hasNewer={hasMore}
          isLoadingOlder={false}
          isLoadingNewer={isLoading}
          overscanPx={150}
          renderMessage={(m) => (
            <MessageSearchResultItem key={m.id} message={m} searchTerm={searchTerm} onClick={onSelectMessage} />
          )}
        />
      ) : (
        <Typography variant='bodySmall' sx={{ px: 1, py: 2, color: 'text.secondary' }}>
          No results
        </Typography>
      )}
    </Grid>
  );
};
